import { NumberHash } from '@app/shared/utils/utils-types';
import { forEach, setWith } from 'lodash';
import { TopicServiceModel } from '@app/origami-api/models/topic-service.model';

class TopicType<T> {
  DocumentPlaceholder: T;
  File: T;

  Answer: T;
  AnswerMetaDataFieldsLookup: T;

  AuditInformation: T;
  AuditInformationMetaDataFieldsLookup: T;
  AuditStatus: T;
  AuditStatusId: T;

  Bulletin: T;

  CalendarTask: T;
  CalendarTaskMetaDataFieldsLookup: T;
  CalendarTaskStatus: T;
  CalendarTaskCategory: T;

  CountryStatus: T;

  HealthAgency: T;
  HealthAgencyMetaDataFieldsLookup: T;
  SubmissionProfile: T;
  SubmissionProfileMetaDataFieldsLookup: T;

  IRBSubmissionProfile: T;
  IRBSubmissionProfileMetaDataFieldsLookup: T;

  Committee: T;

  SSUFolder: T;
  CommunicationLog: T;
  CommunicationLogMetaDataFieldsLookup: T;
  CommunicationType: T;

  ConfidentialityAgreement: T;

  Contact: T;
  ContactType: T;

  Budget: T;
  Contract: T;

  Country: T;
  CountryMetaDataFieldsLookup: T;
  CountryInDataRoom: T;
  CountryInDataRoomMetaDataFieldsLookup: T;

  DeletedDocument: T;
  ObsoleteDocument: T;
  PurgedDocument: T;
  MissingDocument: T;

  Document: T;
  Event: T;
  DocumentCategory: T;
  DocumentMetaDataFieldsLookup: T;
  DocumentStatus: T;

  VisitStatus: T;

  DocumentVerificationChecklist: T;

  DocumentType: T;

  FAQ: T;
  FAQCategory: T;
  FAQMetaDataFieldsLookup: T;

  Filter: T;

  Industry: T;

  InstitutionalReviewBoard: T;
  InstitutionalReviewBoardInDataRoom: T;
  InstitutionalReviewBoardMetaDataFieldsLookup: T;
  InstitutionalReviewBoardInDataRoomMetaDataFieldsLookup: T;
  InstitutionalReviewBoardStatus: T;
  InstitutionalReviewBoardInInvestigativeSite: T;

  AmendmentProfile: T;
  InvestigativeSiteAmendment: T;
  IRBAmendment: T;
  CountryAmendment: T;

  AmendmentProfileMetaDataFieldsLookup: T;
  InvestigativeSiteAmendmentMetaDataFieldsLookup: T;
  IRBAmendmentMetaDataFieldsLookup: T;
  CountryAmendmentMetaDataFieldsLookup: T;

  InvestigativeSite: T;
  InvestigativeSiteMetaDataFieldsLookup: T;
  InvestigativeSiteInDataRoom: T;
  InvestigativeSiteInDataRoomMetaDataFieldsLookup: T;
  InvestigativeSiteIssue: T;
  InvestigativeSiteStatus: T;
  DraftInvestigativeSite: T;

  KofaxTemplate: T;

  SubmissionProfileStatus: T;

  Organization: T;

  Query: T;

  Question: T;
  QuestionLevels: T;
  QuestionMetaDataFieldsLookup: T;

  Program: T;
  ProgramMetaDataFieldsLookup: T;
  ProgramStatus: T;

  StudyProfile: T;

  ProjectURL: T;

  Region: T;

  RegulatoryApprovalStatus: T;

  ReviewDocument: T;

  RoomPhase: T;

  RoomServiceOffering: T;

  SalesAssociate: T;

  Site: T;
  SiteMetaDataFieldsLookup: T;
  SiteCategory: T;
  SiteCloningCategory: T;

  Sponsor: T;

  SSUDocument: T;

  SubjectMatter: T;

  TherapeuticArea: T;

  User: T;
  UserMetaDataFieldsLookup: T;

  DocumentWorkflow: T;
  DeletedDocumentWorkflow: T;
  WorkflowStage: T;
  WorkflowStatus: T;

  DefaultCountryFolder: T;
  WorkflowInitialStageCondition: T;
  DefaultInvestigativeSiteFolder: T;
  eFaxFolder: T;
  Folder: T;
  InboxFolder: T;
  UploadFolder: T;
  ShareFolder: T;
  eSignature: T;
  eSignatureMetaDataFieldsLookup: T;
  ESignatureReason: T;
  ESignatureSignerRole: T;
  IRBUploadFolder: T;

  CountryFolder: T;
  CountryRootFolder: T;

  OrganizationFolder: T;
  OrganizationRootFolder: T;

  InvestigativeSiteFolder: T;
  InvestigativeSitesRootFolder: T;

  RootFolder: T;

  RoomType: T;

  SiteSettings: T;

  InvestigativeSiteReport: T;

  VisitType: T;

  TranslationRequest: T;

  DocumentPreview: T;

  WorkflowStageIssue: T;

  EventTrigger: T;

  RelationshipType: T;

  StudyStatus: T;

  MonitoringVisitType: T;
  MonitoringVisitLog: T;
  IRBSubmissionProfileInvSite: T;
  DeletedPlaceholder: T;
  Incident: T;
  IncidentStatus: T;
  IncidentType: T;
  IncidentTypeCategory: T;
  CAPA: T;
  CapaStatus: T;
  CapaType: T;
  CapaTypeCategory: T;
  ActionItem: T;
  ActionItemStatus: T;
  ActionItemType: T;
  ActionItemTypeCategory: T;
  AuditFailureReason: T;
  Product: T;
  QMSImpact: T;

  QMSAudit: T;
  QMSAuditStatus: T;
  QMSAuditType: T;
  QMSAuditTypeCategory: T;
  QMSFinding: T;
  QMSFindingStatus: T;
  QMSFindingType: T;
  QMSFindingTypeCategory: T;
  QMSSupplierQualification: T;
  QMSSupplierQualificationStatus: T;
  QMSSupplierQualificationType: T;
  QMSSupplierQualificationTypeCategory: T;

  ClientOrganization: T;
  ClientOrganizationInDataRoom: T;
  ClientOrganizationInDataRoomMetaDataFieldsLookup: T;
  OrganizationStatus: T;
  ClientOrganizationMetaDataFieldsLookup: T;
  OrganizationType: T;
  OrganizationSubType: T;
  OrganizationService: T;
  DefaultOrganizationFolder: T;
  QualityApproval: T;
  Investigation: T;
  Assessment: T;
  RecordQuery: T;
  QmsSubFormTemplate: T;

  // TODO: Not sure about this topic name
  Evidence: T;
  Team: T;
  Workflow: T;

  // country workflow topics
  CountryWorkflow: T;
  CountryWorkflowMetaDataFieldsLookup: T;
  CountryWorkflowMilestone: T;
  CountryWorkflowMilestoneMetaDataFieldsLookup: T;
  CountryWorkflowTemplate: T;
  CountryWorkflowTemplateMetaDataFieldsLookup: T;
  CountryMilestoneTemplate: T;
  CountryMilestoneTemplateInWorkflow: T;
  CountryMilestoneTemplateInWorkflowMetaDataFieldsLookup: T;
  CountryMilestoneTemplateMetaDataFieldsLookup: T;
  CountryStatusMetaDataFieldsLookup: T;
  SubmissionProfileDocumentPlaceholder: T;
}

export interface TopicModuleInfo {
  name: string;
  description: string;
  isSubType: boolean;
  topicTypeId: number;
  isHidden: boolean;
  isCustom: boolean;
}

export const TopicTypeName = new TopicType<string>();
export const TopicTypeId = new TopicType<number>();
export const TopicTypeNameById: NumberHash<string> = {};
export const TopicTypeDescriptionById: NumberHash<string> = {};
export const ModulesSet = new Set<string>();
export const TopicTypesByModule: Partial<Record<TopicModule, Record<number, TopicModuleInfo>>> = {};
export enum TopicModule {
  QMS = 'QMS',
}
export function buildTopicModuleInfo(
  topicType: TopicServiceModel.TopicType,
  module: { IsSubType: boolean; HiddenForm: boolean },
): TopicModuleInfo {
  return {
    name: topicType.TypeName,
    description: topicType.Description || topicType.TypeName,
    isSubType: module.IsSubType,
    isHidden: module.HiddenForm,
    topicTypeId: topicType.TopicTypeId,
    isCustom: topicType.IsCustom ?? false,
  };
}

export function updateTopicTypes(topicTypes: TopicServiceModel.TopicType[]) {
  (topicTypes || []).forEach((topicType) => {
    TopicTypeNameById[topicType.TopicTypeId] = topicType.TypeName;
    TopicTypeDescriptionById[topicType.TopicTypeId] = topicType.Description || topicType.TypeName;
    TopicTypeId[topicType.TypeName] = topicType.TopicTypeId;
    TopicTypeName[topicType.TypeName] = topicType.TypeName;

    forEach(topicType.Modules, (module) => {
      ModulesSet.add(module.Module);
      setWith(
        TopicTypesByModule,
        [module.Module, topicType.TopicTypeId],
        buildTopicModuleInfo(topicType, module),
        Object,
      );
    });
  });
}
